import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

export interface LocalCenterProviderSearchParams {
  state: string;
  providerGroupId: number | number[];
  userUuid: string;
  departmentIds?: number[];
}

export function buildLocalCenterProviderSearchConfig(
  params: LocalCenterProviderSearchParams,
  signal?: AbortSignal,
): ApiCallConfig {
  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.LOCAL_CENTER_PROVIDER_SEARCH,
    body: {
      state: params.state,
      providerGroupId: params.providerGroupId,
      userUuid: params.userUuid,
      ...(params.departmentIds?.length ? { departmentId: params.departmentIds } : {}),
    },
    ...(signal ? { signal } : {}),
  };
}
